import MyTeam from "../components/MyTeam";
import useMyTeam from "../hooks/useMyTeam";

const MyTeamPage = () => {
    const useMyTeamProps = useMyTeam();
    return (
        <MyTeam {...useMyTeamProps} />
    )
}

export default MyTeamPage;